import Notifications from './Notifications.page';

export default Notifications;